import { useState } from 'react';

import { Box, Stack } from '@mui/material';
import { Elements } from '@stripe/react-stripe-js';

import { getStripePaymentMethodName } from './utils';
import { EBEPaymentMethodsName } from '../../../../contracts';
import { usePaymentState } from '../../hooks/use-payment-state';
import { useStripeConfig } from '../../hooks/use-stripe-config';
import { AddressElement } from '../AddressElement/AddressElement';
import { useAddressElementRef } from '../AddressElement/hooks/use-address-element-ref';
import { useShowTaxCalculationFields } from '../../hooks/use-show-tax-calculation-fields';
import { PaymentMethodNotSupported } from '../PaymentMethodNotSupported/PaymentMethodNotSupported';
import { StripeExpressCheckoutElement } from '../StripeExpressCheckoutElement/StripeExpressCheckoutElement';

interface ExpressAsApmPaymentWrapperProps {
  paymentMethodName: EBEPaymentMethodsName;
}

export function ExpressAsApmPaymentWrapper({ paymentMethodName }: ExpressAsApmPaymentWrapperProps) {
  const [isApmAvailable, setIsApmAvailable] = useState(true);
  const { paymentElementOptions, paymentElementPromise } = useStripeConfig();
  const setIsPaymentElementLoading = usePaymentState((state) => state.setIsPaymentElementLoading);
  const setIsApmLoading = usePaymentState((state) => state.setIsApmLoading);
  const [isAddressValid, setIsAddressValid] = useState(false);
  const { useTaxCalculationField, showAddressField } = useShowTaxCalculationFields();
  const { AddressElementRef } = useAddressElementRef();
  const isPaymentLoading = usePaymentState((state) => state.isPaymentLoading);

  const isBlockOverlay = (useTaxCalculationField && !isAddressValid) || isPaymentLoading;

  const stripePaymentMethodName = getStripePaymentMethodName(paymentMethodName);

  if (!isApmAvailable) {
    return <PaymentMethodNotSupported />;
  }

  return (
    <Stack spacing={2}>
      {useTaxCalculationField && (
        <AddressElement
          ref={AddressElementRef}
          zipOnly={!showAddressField}
          onValidationChange={(isValid) => {
            setIsAddressValid(isValid);
          }}
        />
      )}
      <Box position={'relative'}>
        {isBlockOverlay && (
          <Box
            position={'absolute'}
            onClick={() => {
              AddressElementRef.current?.validate();
            }}
            width={'100%'}
            height={'100%'}
            zIndex={999999}
          />
        )}
        <Elements stripe={paymentElementPromise} options={paymentElementOptions}>
          <StripeExpressCheckoutElement
            exclusivePaymentMethod={stripePaymentMethodName}
            onReady={(isAvailable) => {
              setIsApmAvailable(isAvailable);
              setIsPaymentElementLoading(false);
              setIsApmLoading(false);
            }}
          />
        </Elements>
      </Box>
    </Stack>
  );
}
